module.exports = __webpack_public_path__ + "img/app-nav-arrow.7d3b4cdf.svg";